document.addEventListener('DOMContentLoaded', () => {
  const SHARE_STATE_VERSION = 1;
  const STEP_ADVANCE_DELAY = 180;

  preloadState();

  const shareModalButton = document.getElementById('open-share-modal-btn');
  if (shareModalButton) {
    shareModalButton.onclick = openShareModal;
  }

  function cloneData(data) {
    if (data === undefined || data === null) return data;
    try {
      return JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.warn('cloneData failed', error);
      return data;
    }
  }

  function preloadState() {
    const payload = getUrlState();
    if (!payload) return;

    if (Array.isArray(payload)) {
      legacyRestore(payload);
      return;
    }

    if (payload && payload.version === SHARE_STATE_VERSION) {
      restoreFromSharePayload(payload);
    } else {
      console.warn('Unsupported share payload format', payload);
      clearStateQueryParam();
    }
  }

  function legacyRestore(legacyState) {
    if (!Array.isArray(legacyState) || !legacyState.length) {
      clearStateQueryParam();
      return;
    }

    const selectedCollection = document
      .getElementById('collections')
      ?.querySelector(`[data-collection="${legacyState[0]?.[0]}"]`);

    selectedCollection?.dispatchEvent(new Event('click'));
    document.querySelector('.tc-next-step')?.dispatchEvent(new Event('click'));

    for (let stepIndex = 1; stepIndex < legacyState.length; stepIndex++) {
      const currentStepState = legacyState[stepIndex];
      const shouldBreak = processStepState(currentStepState);
      if (shouldBreak) break;
      if (stepIndex < legacyState.length - 1) {
        document.querySelector('.tc-next-step')?.dispatchEvent(new Event('click'));
      }
    }

    clearStateQueryParam();
  }

  function restoreFromSharePayload(payload) {
    const clonedState = cloneData(payload.state) || {};
    const clonedPriceObj = cloneData(payload.priceObj) || {};
    const clonedImage = cloneData(payload.image) || {};
    const collectionHandle = payload.currentCollection || clonedState[0];

    if (!collectionHandle) {
      console.warn('Share payload missing collection handle');
      clearStateQueryParam();
      return;
    }

    const collectionEl = document
      .getElementById('collections')
      ?.querySelector(`[data-collection="${collectionHandle}"]`);

    if (!collectionEl) {
      console.warn('Collection element not found for share payload', collectionHandle);
      clearStateQueryParam();
      return;
    }

    if (typeof step === 'number' && step > 0 && typeof changeStep === 'function') {
      while (step > 0) {
        changeStep('prev');
      }
    }

    collectionEl.dispatchEvent(new Event('click'));

    setTimeout(() => {
      try {
        state = clonedState;
        priceObj = clonedPriceObj;
        image = Object.assign({}, image || {}, clonedImage);
      } catch (error) {
        console.warn('Unable to apply share payload state', error);
      }

      currentCollection = collectionHandle;
      window.currentCollection = collectionHandle;

      if (payload.typeDeBijou) typeDeBijou = payload.typeDeBijou;
      if (payload.chaineType) chaineType = payload.chaineType;

      if (typeof renderTotalPrice === 'function') {
        renderTotalPrice();
      }
      if (typeof changeImage === 'function') {
        changeImage();
      }

      const availableSteps = Object.keys(clonedState)
        .map(Number)
        .filter(n => Number.isFinite(n) && n >= 0);
      const fallbackTarget = availableSteps.length ? Math.max(...availableSteps) : 0;
      const requestedStep = Number.isFinite(payload.step) ? payload.step : fallbackTarget;
      const targetStep = Math.max(0, Math.min(requestedStep, fallbackTarget));

      if (typeof window.restoreStepState === 'function') {
        window.restoreStepState();
      }

      const nextBtn = document.querySelector('.tc-next-step');
      let safeguard = 0;

      const advance = () => {
        if (!nextBtn) return finalize();
        if (typeof step !== 'number') return finalize();
        if (step >= targetStep) return finalize();
        if (safeguard++ > 12) return finalize();

        nextBtn.click();

        setTimeout(() => {
          if (typeof window.restoreStepState === 'function') {
            window.restoreStepState();
          }
          advance();
        }, STEP_ADVANCE_DELAY);
      };

      const finalize = () => {
        if (typeof window.restoreStepState === 'function') {
          window.restoreStepState();
        }
      };

      advance();
      clearStateQueryParam();
    }, 120);
  }

  function clearStateQueryParam() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('state')) {
      url.searchParams.delete('state');
      window.history.replaceState({}, document.title, url.toString());
    }
  }

  function processStepState(currentStepState) {
    const stepEl = document.getElementById('step');
    let isBreak = false;

    for (const stepImageSrc of currentStepState) {
      const selector = `img[alt="${stepImageSrc}"]`;
      const elements = stepEl.querySelectorAll(selector);

      if (!elements.length) {
        isBreak = true;
        break;
      }

      elements.forEach(element => {
        element.closest('.product')?.dispatchEvent(new Event('click'));
        element.parentElement?.dispatchEvent(new Event('click'));
        element.closest('li')?.dispatchEvent(new Event('click'));
      });
    }

    if (isBreak) return isBreak;
  }

  function getUrlState() {
    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('state');
    if (!stateParam) return null;

    const attempts = [stateParam];
    try {
      attempts.unshift(decodeURIComponent(stateParam));
    } catch {
      // ignore decode errors
    }

    for (const candidate of attempts) {
      try {
        return JSON.parse(candidate);
      } catch {
        // continue
      }
    }

    return null;
  }

  function buildSharePayload() {
    if (typeof state === 'undefined') return null;
    try {
      return {
        version: SHARE_STATE_VERSION,
        generatedAt: Date.now(),
        currentCollection,
        typeDeBijou,
        chaineType,
        step,
        state: cloneData(state),
        priceObj: cloneData(priceObj),
        image: cloneData(image),
      };
    } catch (error) {
      console.error('Failed to build share payload', error);
      return null;
    }
  }

  function openShareModal() {
    const payload = buildSharePayload();
    if (!payload) {
      showShareStatus('Configuration introuvable');
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('state', encodeURIComponent(JSON.stringify(payload)));

    const input = document.getElementById('share-link-input');
    input.value = url.toString();
    input.focus();
    input.setSelectionRange(0, 0);

    document.getElementById('share-modal-overlay').style.display = 'block';
    document.getElementById('share-modal').style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.getElementById('share-link-input').focus();
    updateSocialLinks();
  }

  function closeShareModal() {
    document.getElementById('share-modal-overlay').style.display = 'none';
    document.getElementById('share-modal').style.display = 'none';
    document.body.style.overflow = '';
  }

  document.getElementById('share-modal-close').onclick = closeShareModal;
  document.getElementById('share-modal-overlay').onclick = closeShareModal;
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeShareModal();
  });

  document.getElementById('share-copy-btn').onclick = function() {
    const link = document.getElementById('share-link-input').value;
    navigator.clipboard.writeText(link).then(() => {
      showShareStatus('Link copied!');
    });
  };

  function updateSocialLinks() {
    const url = encodeURIComponent(document.getElementById('share-link-input').value);
    document.getElementById('share-facebook').href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    document.getElementById('share-pinterest').href = `https://pinterest.com/pin/create/button/?url=${url}`;
    document.getElementById('share-instagram').href = `https://www.instagram.com/`;
  }

  document.getElementById('share-email').onclick = function(e) {
    e.preventDefault();
    const link = document.getElementById('share-link-input').value;
    const subject = encodeURIComponent('Check out this link!');
    const body = encodeURIComponent(link);
    window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
  };

  function showShareStatus(msg) {
    const status = document.getElementById('share-status');
    status.innerText = msg;
    status.classList.add('active');
    setTimeout(() => status.classList.remove('active'), 1700);
  }
});
